<template>
  <div class="form">
    <div class="form__header">
      <h3>Перенести {{ moveStudent ? 'ученика' : 'класс' }}</h3>
    </div>

    <div class="form__body">
      <p class="form__field">
        <span class="l_title">Преподаватель</span>        
        <v-select 
          label="name" 
          :options="teachers" 
          v-model="formData.teacher_id" 
          :reduce="option => option.id"
          class="required"
          :class="{
            valid: formData.teacher_id,
            invalid: !formData.teacher_id,
          }"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>        
      </p>

      <Input 
        class="form__field" 
        v-model="formData.key" 
        label="Пароль" 
        type="text" 
        id="password" 
        :required="true" 
      />
    </div>
    <div class="form__footer">
      <SubmitButton :isValid="isValid" @submit="sendForm" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
export default {
  mixins: [ form_mix ],
  props: ['moveStudent', 'data'],
  inject: ['http'],
  data() {
    return {
      requiredKeys: ['teacher_id', 'key'],
      teachers: [],
      formData: {
        teacher_id: '',
        key: ''
      }
    }
  },
  methods: {
    getTeachers() {
      this.http.post('onGetTeachersList').then(res => {
        this.teachers = res.data
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    },
    sendForm() {
      let path = this.moveStudent ? 'onMoveStudent' : 'onMoveClass'
      this.formData.id = this.data
      
      this.http.post(path, this.formData).then((res) => {
        if (res.data.result === 'Некорректный пароль') {
          swal(res.data.result, '', 'error')
        } else {
          this.$emit('close-popup')
          this.$emit('move-class', this.formData.id)                   
        }        
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }
  },
  created() {
    this.getTeachers()
  }
}
</script>